import type { JSX } from 'react';
import type { ChipVariant } from '@/types';

interface ChipProps {
  children: React.ReactNode;
  variant: ChipVariant;
}

export default function Chip({ children, variant }: ChipProps): JSX.Element {
  return (
    <span className={`chip chip--${variant}`}>{children}</span>
  );
}
